Bingo.Preview = {};

Bingo.Preview.initialized = false;

Bingo.Preview.init = function () {
    this.renewTextInToggleButtons();
    if (Bingo.Preview.initialized) {
        return;
    }
    $(document).on('click', '.js-preview__tableToggler', function () {
        const preview = $(this).closest('.O-preview');
        const table = preview.find('.js-preview__table');
        const text = $(this).find('.js-preview__tableTogglerText');
        if ($(this).hasClass('-active')) {
            table.slideUp('slow', () => {
                table.removeClass('-opened');
            });
            $(this).removeClass('-active');
            text.text(text.attr('data-text-show'));
        } else {
            table.slideDown('slow', () => {
                table.addClass('-opened');
            });
            $(this).addClass('-active');
            text.text(text.attr('data-text-hide'));
        }
    });
    Bingo.Preview.initialized = true;
};

Bingo.Preview.renewTextInToggleButtons = function () {
    $.each($('.js-preview__tableToggler'), function () {
        const togglerText = $(this).find('.js-preview__tableTogglerText');
        if ($(this).hasClass('-active')) {
            togglerText.text(togglerText.attr('data-text-hide'));
        } else {
            togglerText.text(togglerText.attr('data-text-show'));
        }
    });
};
